import moment from 'moment'
import React from 'react'
import {v4 as uuidv4} from 'uuid'
import {obsColWrapperPDFData, observationPdfKeys} from './ObsConstans'
const {useRef, useState, useMemo, useCallback, useEffect} = require('react')
const {
    respirationDataRange,
    spO2DataRange,
    pulseDataRange,
    bloodPressureDataRange,
    consciousnessOptions,
    temperatureDataRange,
    holderValue,
    shortenValueKeys,
    colHeaderBackground,
    colHeaderColor,
    setLineChartDrawn,
} = require('../observations/Constants')
const {
    getValueByKeyAtPosition,
    getShortenFromValue,
    getNewsColor,
    getValueByKeyForChart,
    getIndexOfValueInMultiCol,
} = require('../observations/Utils')
const {convertKeyToLabel} = require('../table-utils/TableUtils')
const {Column} = require('primereact/column')
const {DataTable} = require('primereact/datatable')
const ObservationPdf = ({exportData = []}) => {
    const chartWrapper = useRef(null)
    const [showColors, setShowColors] = useState(true)

    //#region Health Record
    const data = useMemo(() => {
        if (exportData && exportData?.length > 0 && !!exportData[0]) {
            return exportData
                ?.sort((a, b) =>
                    b.created_at && a.created_at
                        ? moment(b.created_at).toDate() -
                          moment(a.created_at).toDate()
                        : 0,
                )
                ?.reverse()
        }
        return []
    }, [exportData])
    //#endregion

    //#region OBS TABLE
    const convertMultipleColData = useCallback(
        (key, data, idx, isShorten = false) => {
            let returnValue = ''
            // eslint-disable-next-line default-case
            switch (key) {
                case observationPdfKeys.respiration:
                    returnValue = getValueByKeyAtPosition(
                        respirationDataRange,
                        key,
                        data,
                        idx,
                    )
                    break
                case observationPdfKeys.oxygen:
                    returnValue = getValueByKeyAtPosition(
                        spO2DataRange,
                        key,
                        data,
                        idx,
                    )
                    break
                case 'heartRate':
                    returnValue = getValueByKeyAtPosition(
                        pulseDataRange,
                        key,
                        data,
                        idx,
                    )
                    break
                case 'bloodPressure':
                    returnValue = getValueByKeyAtPosition(
                        bloodPressureDataRange,
                        observationPdfKeys.diastolic,
                        data,
                        idx,
                    )
                    if (!returnValue) {
                        returnValue = getValueByKeyAtPosition(
                            bloodPressureDataRange,
                            observationPdfKeys.systolic,
                            data,
                            idx,
                        )
                    }
                    break
                case 'levelOfConsciousness':
                    if (
                        idx === 0 &&
                        data['levelOfConsciousness'] &&
                        data['levelOfConsciousness'] === 'alert'
                    ) {
                        returnValue = isShorten
                            ? getShortenFromValue(
                                  data['levelOfConsciousness'],
                                  consciousnessOptions,
                              )
                            : ''
                    } else {
                        if (idx === 0) {
                            returnValue = ''
                        } else {
                            returnValue =
                                data[key] && data[key] !== 'alert' && isShorten
                                    ? getShortenFromValue(
                                          data[key],
                                          consciousnessOptions,
                                      )
                                    : ''
                        }
                    }

                    if (idx === 1 && data[key] && data[key] === 'confusion') {
                        returnValue += data['confusion'] ? '(Y)' : '(N)'
                    }
                    break
                case observationPdfKeys.temperature:
                    returnValue = getValueByKeyAtPosition(
                        temperatureDataRange,
                        key,
                        data,
                        idx,
                    )
                    break
            }

            if (showColors && returnValue === '') {
                return holderValue
            } else {
                return returnValue
            }
        },
        [showColors],
    )

    const renderColData = useCallback(
        (rowData, data, i) => (
            <div>
                {rowData.colNumber > 1 &&
                rowData.extraColData &&
                rowData.extraColData.length > 0 ? (
                    <div
                        className="col-12 p-0 flex flex-column align-items-center justify-content-between"
                        style={{height: rowData.extraColData.length * 23}}>
                        {rowData.extraColData.map((row, idx) => {
                            const dataValue = convertMultipleColData(
                                rowData.key,
                                data,
                                idx,
                                true,
                            )

                            return (
                                <div
                                    key={`${rowData.key}-${row}-colData-${idx}`}
                                    className={`font-bold ${
                                        dataValue && dataValue !== holderValue
                                            ? 'px-2'
                                            : 'px-3'
                                    } tooltip px-0 text-center`}
                                    style={{
                                        backgroundColor: rowData.colors
                                            ? rowData.colors[idx]
                                            : '',
                                        cursor: 'pointer',
                                        height: '23px',
                                        width: '100%',
                                        marginBottom: '0.5px',
                                        paddingTop: '2px',
                                        border: '0.1px solid rgba(204, 204, 204, 0.1)',
                                    }}>
                                    {dataValue && dataValue !== holderValue && (
                                        <span className="tooltiptext-top">
                                            {rowData.label ? (
                                                <div>{rowData.label}</div>
                                            ) : (
                                                ''
                                            )}
                                            {rowData.extraColData[idx] ? (
                                                <div>
                                                    <div>
                                                        {
                                                            rowData
                                                                .extraColData[
                                                                idx
                                                            ]
                                                        }
                                                    </div>{' '}
                                                    {shortenValueKeys.includes(
                                                        rowData.key,
                                                    ) ? (
                                                        <div>
                                                            {convertMultipleColData(
                                                                rowData.key,
                                                                data,
                                                                idx,
                                                                false,
                                                            )}
                                                        </div>
                                                    ) : (
                                                        ''
                                                    )}
                                                </div>
                                            ) : (
                                                ''
                                            )}
                                        </span>
                                    )}
                                    <span id={`${rowData.key}-${i}-${idx}`}>
                                        {dataValue}
                                    </span>
                                </div>
                            )
                        })}
                    </div>
                ) : (
                    <div
                        className="flex justify-content-center align-items-center m-0 p-0"
                        style={{
                            backgroundColor:
                                rowData.key === observationPdfKeys.news
                                    ? getNewsColor(data[rowData.key])
                                    : '',
                        }}>
                        <div className={`text-center font-bold`}>
                            {rowData.key === observationPdfKeys.year ? (
                                <p>
                                    {moment(
                                        new Date(
                                            data[observationPdfKeys.createdAt],
                                        ),
                                    ).format('YYYY')}
                                </p>
                            ) : rowData.key === observationPdfKeys.date ? (
                                <p>
                                    {moment(
                                        new Date(
                                            data[observationPdfKeys.createdAt],
                                        ),
                                    ).format('DD/MM')}
                                </p>
                            ) : rowData.key === observationPdfKeys.time ? (
                                <p>
                                    {moment(
                                        new Date(
                                            data[observationPdfKeys.createdAt],
                                        ),
                                    ).format('HH:mm:ss')}
                                </p>
                            ) : (
                                <React.Fragment>
                                    <div className="tooltip mb-0">
                                        {rowData.key !==
                                            observationPdfKeys.comment && (
                                            <span className={'tooltiptext-top'}>
                                                <div className="text-center">
                                                    <p className="text-center">
                                                        {convertKeyToLabel(
                                                            rowData.key,
                                                        )}
                                                        {': '}
                                                        {data[rowData.key]}
                                                    </p>
                                                </div>
                                            </span>
                                        )}

                                        {rowData.key ===
                                        observationPdfKeys.comment ? (
                                            <i className="pi pi-bookmark pointer"></i>
                                        ) : rowData.key ===
                                          observationPdfKeys.anySupplementaryOxygen ? (
                                            <p>
                                                {data[
                                                    'any_supplementary_oxygen'
                                                ]
                                                    ? convertKeyToLabel(
                                                          data[
                                                              'any_supplementary_oxygen'
                                                          ],
                                                      )
                                                    : ''}
                                            </p>
                                        ) : (
                                            <p>{data[rowData.key]}</p>
                                        )}
                                    </div>
                                </React.Fragment>
                            )}
                        </div>
                    </div>
                )}
            </div>
        ),
        [convertMultipleColData],
    )

    const renderEmptyColData = rowData => (
        <div>
            {rowData.colNumber > 1 &&
            rowData.extraColData &&
            rowData.extraColData.length > 0 ? (
                <div
                    className="col-12 p-0 flex flex-column align-items-center justify-content-between"
                    style={{height: rowData.extraColData.length * 23}}>
                    {rowData.extraColData.map((row, idx) => {
                        return (
                            <div
                                key={`${uuidv4()}`}
                                className={`font-bold px-3 tooltip px-0 text-center`}
                                style={{
                                    backgroundColor: rowData.colors
                                        ? rowData.colors[idx]
                                        : '',
                                    cursor: 'pointer',
                                    height: '23px',
                                    width: '100%',
                                    marginBottom: '0.5px',
                                    paddingTop: '2px',
                                    border: '0.1px solid rgba(204, 204, 204, 0.1)',
                                }}>
                                <span>{` `}</span>
                            </div>
                        )
                    })}
                </div>
            ) : (
                <div
                    className={`${
                        rowData.key === 'Comment' ? 'tooltip' : ''
                    } text-center`}>
                    {` `}
                </div>
            )}
        </div>
    )

    const renderColBody = useCallback(() => {
        let cols = []
        for (let i = 0; i < 12; i++) {
            cols.push(
                <Column
                    key={`${data[i]}-${i}`}
                    body={rowData => {
                        return data[i]
                            ? renderColData(rowData, data[i], i)
                            : renderEmptyColData(rowData)
                    }}
                />,
            )
        }

        return cols
    }, [data, renderColData])

    //#region COL HEADER
    const renderColWrapper = useCallback((rowData, type) => {
        return (
            <div
                style={{
                    backgroundColor: colHeaderBackground,
                    minWidth: '120px',
                }}>
                {rowData.colNumber > 1 ? (
                    <div className="grid p-0">
                        <div className="col-6 p-0 flex justify-content-center align-items-center font-bold p-0">
                            <div
                                className="text-center"
                                style={
                                    rowData.key !== 'level_Of_Consciousness'
                                        ? {
                                              transform: 'rotate(270deg)',
                                              color: colHeaderColor,
                                          }
                                        : {color: colHeaderColor}
                                }>
                                {rowData.label}
                            </div>
                        </div>
                        <div className="col-6 p-0">
                            <div
                                className="p-0 font-bold"
                                style={{
                                    backgroundColor: 'white',
                                }}>
                                {rowData.extraColData.map((extraData, eIdx) => (
                                    <div
                                        key={`${type}-${extraData}-${eIdx}`}
                                        className="p-1 text-center font-bold">
                                        <label className="font-fold">
                                            {extraData}
                                        </label>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                ) : (
                    <div
                        className="flex justify-content-center align-items-center font-bold"
                        style={{
                            minWidth: 40,
                            padding:
                                rowData?.key === observationPdfKeys.news
                                    ? '3px'
                                    : 10,
                            color: colHeaderColor,
                            textAlign: 'center',
                        }}>
                        {rowData.label}
                    </div>
                )}
            </div>
        )
    }, [])
    //#endregion

    //#region Draw Chart Lines

    const [reDraw, setReDraw] = useState(0)

    var resizeTimeOut

    useEffect(() => {
        window?.addEventListener('resize', () => {
            clearTimeout(resizeTimeOut)

            removeExistingLineCharts()

            resizeTimeOut = setTimeout(() => {
                drawLineCharts()
            }, 200)
        })

        return () => {
            clearTimeout(resizeTimeOut)

            window?.removeEventListener('resize', () => {})
        }
    }, [])

    const removeExistingLineCharts = useCallback(() => {
        const lineChartWrapper =
            window.document.getElementById('leader-line-defs')
        if (lineChartWrapper) {
            lineChartWrapper.remove()
        }

        const lines = window.document.getElementsByClassName('leader-line')
        if (lines && lines.length > 0) {
            for (var i = lines.length - 1; i >= 0; i--) {
                lines[i].remove()
            }
        }
    }, [])

    const drawChart = useCallback((data, key) => {
        if (!data || !key) {
            return
        }

        let chartData = getValueByKeyForChart(data, key)
        if (chartData && chartData.length > 0) {
            const lastIndex = chartData.lastIndexOf(
                chartData[chartData.length - 1],
            )
            const colData = obsColWrapperPDFData.find(x => x.key === key)

            for (let i = 0; i < chartData.length; i++) {
                if (key === observationPdfKeys.bloodPressure) {
                    const systolicIndex = getIndexOfValueInMultiCol(
                        colData.dataRange,
                        chartData[i].systolic,
                    )
                    const diastolicIndex = getIndexOfValueInMultiCol(
                        colData.dataRange,
                        chartData[i].diastolic,
                    )

                    if (systolicIndex !== null && diastolicIndex !== null) {
                        try {
                            const start = `${key}-${chartData[i].systolicIndex}-${systolicIndex}`
                            const end = `${key}-${chartData[i].diastolicIndex}-${diastolicIndex}`

                            const firstLabel =
                                chartData[i].bloodPressurePosition &&
                                chartData[i].bloodPressureLimb !== 'undefined'
                                    ? chartData[i].bloodPressureLimb.substring(
                                          0,
                                          2,
                                      )
                                    : ''
                            const secondLabel =
                                chartData[i].bloodPressurePosition &&
                                chartData[i].bloodPressurePosition !==
                                    'undefined'
                                    ? chartData[
                                          i
                                      ].bloodPressurePosition.substring(0, 2)
                                    : ''

                            if (start && end) {
                                try {
                                    new window.LeaderLine(
                                        document.getElementById(start),
                                        document.getElementById(end),
                                        {
                                            size: 2,
                                            // path: 'straight',
                                            color: 'black',
                                            startPlug: 'disc',
                                            endPlug: 'disc',
                                            startLabel:
                                                window.LeaderLine.captionLabel(
                                                    `${firstLabel}
                                                ${
                                                    firstLabel && secondLabel
                                                        ? '/'
                                                        : ''
                                                }${secondLabel}`,
                                                    {
                                                        color: 'black',
                                                        fontWeight: 'bold',
                                                        fontSize: 12,
                                                        stroke: 'red',
                                                        offset: [-20, 10],
                                                    },
                                                ),
                                        },
                                    )
                                } catch (error) {}
                            }
                        } catch (error) {}
                    }
                } else {
                    if (
                        lastIndex !== i &&
                        chartData[i].index === chartData[i + 1].index - 1
                    ) {
                        const dataIndexInCol = getIndexOfValueInMultiCol(
                            colData.dataRange,
                            chartData[i].value,
                        )
                        const dataIndexInColIncreased =
                            getIndexOfValueInMultiCol(
                                colData.dataRange,
                                chartData[i + 1].value,
                            )
                        if (dataIndexInCol !== null) {
                            try {
                                const start = `${key}-${chartData[i].index}-${dataIndexInCol}`
                                const end = `${key}-${
                                    chartData[i + 1].index
                                }-${dataIndexInColIncreased}`
                                new window.LeaderLine(
                                    document.getElementById(start),
                                    document.getElementById(end),
                                    {
                                        size: 2,
                                        path: 'straight',
                                        color: 'black',
                                        startPlug: 'disc',
                                    },
                                )
                            } catch (error) {}
                        }
                    }
                }
            }
        }

        // moveChartToObs()
    }, [])

    const drawLineCharts = useCallback(() => {
        removeExistingLineCharts()

        if (data && data.length > 0) {
            const chartKeys = [
                observationPdfKeys.respiration,
                observationPdfKeys.oxygen,
                observationPdfKeys.bloodPressure,
                observationPdfKeys.heartRate,
                observationPdfKeys.temperature,
            ]

            for (let i = 0; i < chartKeys.length; i++) {
                drawChart(data, chartKeys[i])
            }

            setLineChartDrawn(true)
        }
    }, [data, drawChart, removeExistingLineCharts])

    const removeLinesIfOverflow = () => {
        const lines = window.document.getElementsByClassName('leader-line')
        if (lines && lines.length > 0) {
            for (var i = lines.length - 1; i >= 0; i--) {
                if (lines[i]) {
                    if (lines[i]?.style.left) {
                        const left = parseInt(lines[i].style.left)
                        if (left < 55) {
                            lines[i].remove()

                            continue
                        }
                    }

                    if (lines[i]?.style.right) {
                        const right = parseInt(lines[i].style.right)
                        if (right < 55) {
                            lines[i].remove()

                            continue
                        }
                    }
                }
            }
        }
    }

    const handleScrollTable = useCallback(
        e => {
            removeExistingLineCharts()
            drawLineCharts()
            removeLinesIfOverflow()
        },
        [drawLineCharts, removeExistingLineCharts],
    )

    useEffect(() => {
        if (data && data?.length > 0) {
            drawLineCharts()
        }

        return () => {
            removeExistingLineCharts()
        }
    }, [data, drawLineCharts, removeExistingLineCharts])
    //#endregion

    //#region OBS CHART
    const renderObsChart = useCallback(() => {
        return (
            <DataTable
                ref={chartWrapper}
                rowClassName="obs-table-row-chart"
                onScrollCapture={e => handleScrollTable(e)}
                value={obsColWrapperPDFData.filter(
                    item => item?.key !== 'initials' && item?.key !== 'device',
                )}
                showGridlines
                responsiveLayout="scroll"
                rowHover>
                <Column
                    frozen={true}
                    body={rowData => renderColWrapper(rowData, 'head')}
                    style={{
                        backgroundColor: 'white',
                        width: '8%',
                    }}
                />
                {renderColBody()}
            </DataTable>
        )
    }, [chartWrapper, renderColWrapper, handleScrollTable, renderColBody])
    //#endregion

    return (
        <div className="w-full obs-table-chart mb-6">
            {renderObsChart()}
            <div id={'obs-line-leaders'}></div>
        </div>
    )
}

export default ObservationPdf
